export default __webpack_public_path__ + "static/1150-c34517c5faab4f5723600a679bb0a2cc.gif";